export const GET_PUBLISH_SUCCESS = 'GET_PUBLISH_SUCCESS';
export const GET_PUBLISH_FAILURE = 'GET_PUBLISH_FAILURE';
export const GET_PUBLISH_REQUEST = 'GET_PUBLISH_REQUEST';
